import { FC, HTMLAttributes } from 'react';
import { styled } from '@mui/material/styles';

export interface AppBarLogoProps extends HTMLAttributes<HTMLElement> {
  [key: string]: any;
  src: any; // todo: refactor it using path or file? for example: File!
  alt: string;
}

const AppBarLogoRoot = styled('img', {
  name: 'O2AppBar',
  slot: 'Logo',
})(({ theme }) => ({
  width: '80px',
  [theme.breakpoints.up('md')]: {
    width: '104px',
  },
}));

const AppBarLogo: FC<AppBarLogoProps> = (props) => {
  const { src, alt, ...other } = props;

  return <AppBarLogoRoot src={src} alt={alt} {...other} />;
};

export default AppBarLogo;
